import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../../components/inputs/input/input';
import { Note } from '../../../../../../../../components/note/note';
import ListLayout from '../../../../../../../../components/layouts/list-layout/list-layout';
import { IValidationGroup } from '../../../../../../../../hooks/validation-group/validation-group-hook';
import FedexV2MfaStore from '../../../../../stores/credentials/shipping/fedex-v2/fedex-v2-mfa-store';

interface IProps {
    mfa: FedexV2MfaStore;
    modalVGroup: IValidationGroup;
}

const FedexV2RegistrationMfaInputStep: React.FC<IProps> = observer(({ mfa, modalVGroup }) => (
    <ListLayout>
        <Note body="Enter the 6-digit PIN sent to your FedEx account contact." />
        <FormFieldLine required label="Secure code PIN" key="secureCodePin">
            <Input
                value={mfa.secureCodePin}
                onChange={mfa.setSecureCodePin}
                validationGroup={modalVGroup}
                required
            />
        </FormFieldLine>
    </ListLayout>
));

export default FedexV2RegistrationMfaInputStep;
